// src/components/Loan.js

import React, {
    useEffect,
    useState,
    useMemo
} from "react";


import {
    Card,
    Row,
    Col,
    Statistic,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Space,
    Tag,
    Popconfirm,
    Empty,
    Spin,
    message
} from "antd";


import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    SearchOutlined,
    DollarOutlined,
    FileTextOutlined
} from "@ant-design/icons";


import Swal from "sweetalert2";


import api from "../../api/api";





function Loan(){



    // ================================
    // FORM
    // ================================


    const [form] = Form.useForm();





    // ================================
    // STATES
    // ================================


    const [loans,setLoans] = useState([]);


    const [loading,setLoading] = useState(false);



    const [saving,setSaving] = useState(false);




    const [totalAmount,setTotalAmount] = useState(0);




    const [searchTerm,setSearchTerm] = useState("");




    const [modalOpen,setModalOpen] = useState(false);




    const [editId,setEditId] = useState(null);






    // ================================
    // FETCH LOANS
    // ================================


    const fetchLoans = async()=>{


        try{


            setLoading(true);



            const response = await api.get(
                "/loans/"
            );



            setLoans(
                response.data
            );



            const totalResponse =
                await api.get(
                    "/loans/total-loan-amount/"
                );



            setTotalAmount(
                Number(
                    totalResponse.data.total_loan_amount
                )
            );



        }
        catch(error){


            console.log(
                error
            );


            Swal.fire(
                "Error",
                "Unable to load loans",
                "error"
            );


        }
        finally{


            setLoading(false);


        }


    };







    // ================================
    // INITIAL LOAD
    // ================================


    useEffect(()=>{


        fetchLoans();


    },[]);







    // ================================
    // SEARCH
    // ================================


    const filteredLoans = useMemo(()=>{


        return loans.filter((loan)=>{


            const search =
                searchTerm.toLowerCase();



            return (

                loan.full_name
                ?.toLowerCase()
                .includes(search)

                ||

                loan.description
                ?.toLowerCase()
                .includes(search)

            );


        });


    },[
        loans,
        searchTerm
    ]);







    // ================================
    // STATISTICS
    // ================================


    const stats = {


        totalLoans:
            loans.length,


        totalAmount:
            totalAmount,


        average:

            loans.length

            ?

            totalAmount / loans.length

            :

            0

    };








    // ================================
    // OPEN CREATE MODAL
    // ================================


    const openCreate = ()=>{


        setEditId(null);


        form.resetFields();


        setModalOpen(true);


    };








    // ================================
    // OPEN EDIT MODAL
    // ================================


    const openEdit = (record)=>{


        setEditId(
            record.id
        );



        form.setFieldsValue({


            full_name:
                record.full_name,


            description:
                record.description,


            amount:
                record.amount,


            date_taken:
                record.date_taken,


            date_due:
                record.date_due



        });



        setModalOpen(true);


    };








    // ================================
    // CLOSE MODAL
    // ================================


    const closeModal = ()=>{


        setModalOpen(false);


        setEditId(null);


        form.resetFields();


    };








    // ================================
    // SUBMIT CREATE / UPDATE
    // ================================


    const handleSubmit = async(values)=>{


        try{


            setSaving(true);



            if(editId){


                await api.put(

                    `/loans/${editId}/`,

                    values

                );



                Swal.fire(
                    "Updated",
                    "Loan updated successfully",
                    "success"
                );


            }
            else{


                await api.post(

                    "/loans/",

                    values

                );



                Swal.fire(
                    "Created",
                    "Loan created successfully",
                    "success"
                );


            }




            closeModal();


            fetchLoans();



        }
        catch(error){


            console.log(error);



            Swal.fire(
                "Error",
                "Unable to save loan",
                "error"
            );


        }
        finally{


            setSaving(false);


        }


    };







    // ================================
    // DELETE
    // ================================
    const deleteLoan = async(id)=>{


        try{


            await api.delete(

                `/loans/${id}/`

            );



            Swal.fire(
                "Deleted",
                "Loan removed successfully",
                "success"
            );



            fetchLoans();



        }
        catch(error){


            Swal.fire(
                "Error",
                "Delete failed",
                "error"
            );


        }


    };




    // ================================
    // TABLE COLUMNS
    // ================================




    // ================================
    // TABLE COLUMNS
    // ================================


    const columns = [


        {
            title:"Full Name",
            dataIndex:"full_name",
            key:"full_name",

            render:(text)=>(
                <b>
                    {text}
                </b>
            )

        },



        {
            title:"Description",
            dataIndex:"description",
            key:"description",

            render:(text)=>(
                <span>
                    {text}
                </span>
            )

        },



        {
            title:"Amount",
            dataIndex:"amount",
            key:"amount",

            render:(amount)=>(

                <Tag color="green">

                    $
                    {Number(amount)
                    .toLocaleString(
                        undefined,
                        {
                            minimumFractionDigits:2
                        }
                    )}

                </Tag>

            )

        },



        {
            title:"Date Taken",
            dataIndex:"date_taken",
            key:"date_taken",

            render:(date)=>(

                <Tag color="blue">

                    {date}

                </Tag>

            )

        },



        {
            title:"Date Due",
            dataIndex:"date_due",
            key:"date_due",

            render:(date)=>(

                <Tag color="orange">

                    {date}

                </Tag>

            )

        },



        {
            title:"Actions",
            key:"actions",

            align:"center",


            render:(_,record)=>(


                <Space>


                    <Button

                        type="primary"

                        icon={
                            <EditOutlined/>
                        }

                        onClick={()=>
                            openEdit(record)
                        }

                    />



                    <Popconfirm

                        title="Delete this loan?"

                        description="This action cannot be undone."

                        onConfirm={()=>
                            deleteLoan(record.id)
                        }

                        okText="Delete"

                        cancelText="Cancel"

                    >

                        <Button

                            danger

                            icon={
                                <DeleteOutlined/>
                            }

                        />


                    </Popconfirm>



                </Space>


            )


        }


    ];









    return (


        <div
            style={{
                padding:20
            }}
        >



            {/* ================================
                HEADER
            ================================= */}



            <Row

                justify="space-between"

                align="middle"

                style={{
                    marginBottom:20
                }}

            >


                <Col>


                    <h2>

                        <FileTextOutlined/>

                        {" "}
                        Loan Management

                    </h2>


                    <p>

                        Manage borrower loans and payments

                    </p>


                </Col>




                <Col>


                    <Button

                        type="primary"

                        size="large"

                        icon={
                            <PlusOutlined/>
                        }

                        onClick={openCreate}

                    >

                        Add Loan

                    </Button>


                </Col>



            </Row>








            {/* ================================
                STATISTICS CARDS
            ================================= */}



            <Row

                gutter={[
                    16,
                    16
                ]}

                style={{
                    marginBottom:25
                }}

            >



                <Col

                    xs={24}

                    md={8}

                >

                    <Card>


                        <Statistic

                            title="Total Loans"

                            value={
                                stats.totalLoans
                            }

                            prefix={
                                <FileTextOutlined/>
                            }

                        />


                    </Card>


                </Col>






                <Col

                    xs={24}

                    md={8}

                >

                    <Card>


                        <Statistic

                            title="Total Loan Amount"

                            value={
                                stats.totalAmount
                            }

                            precision={2}

                            prefix="$"

                        />


                    </Card>


                </Col>







                <Col

                    xs={24}

                    md={8}

                >

                    <Card>


                        <Statistic

                            title="Average Loan"

                            value={
                                stats.average
                            }

                            precision={2}

                            prefix="$"

                        />


                    </Card>


                </Col>



            </Row>










            {/* ================================
                SEARCH
            ================================= */}



            <Card

                style={{
                    marginBottom:20
                }}

            >


                <Input


                    size="large"


                    prefix={
                        <SearchOutlined/>
                    }


                    placeholder=
                    "Search by name or description..."


                    value={
                        searchTerm
                    }


                    onChange={(e)=>
                        setSearchTerm(
                            e.target.value
                        )
                    }


                    allowClear


                />


            </Card>










            {/* ================================
                TABLE
            ================================= */}



            <Card>


                {
                    loading

                    ?

                    (

                        <div

                            style={{
                                textAlign:"center",
                                padding:40
                            }}

                        >

                            <Spin size="large"/>

                        </div>

                    )


                    :


                    filteredLoans.length === 0


                    ?

                    (

                        <Empty

                            description="No loans found"

                        />

                    )


                    :


                    (

                        <Table


                            columns={
                                columns
                            }


                            dataSource={
                                filteredLoans
                            }


                            rowKey="id"


                            pagination={{

                                pageSize:10,

                                showSizeChanger:true,

                                showTotal:(total)=>
                                    `Total ${total} loans`

                            }}


                            bordered


                            scroll={{
                                x:true
                            }}


                        />


                    )


                }


            </Card>










            {/* ================================
                ADD / EDIT MODAL
            ================================= */}



            <Modal


                title={

                    editId

                    ?

                    "Update Loan"

                    :

                    "Add New Loan"

                }


                open={
                    modalOpen
                }


                onCancel={
                    closeModal
                }


                footer={null}


                centered


            >



                <Form


                    layout="vertical"


                    form={
                        form
                    }


                    onFinish={
                        handleSubmit
                    }


                >





                    <Form.Item


                        label="Full Name"


                        name="full_name"


                        rules={[
                            {
                                required:true,
                                message:
                                "Enter borrower name"
                            }
                        ]}


                    >


                        <Input

                            placeholder=
                            "Borrower full name"

                        />


                    </Form.Item>







                    <Form.Item


                        label="Description"


                        name="description"


                        rules={[
                            {
                                required:true,
                                message:
                                "Enter description"
                            }
                        ]}


                    >


                        <Input.TextArea


                            rows={3}


                            placeholder=
                            "Loan description"


                        />


                    </Form.Item>







                    <Form.Item


                        label="Amount"


                        name="amount"


                        rules={[
                            {
                                required:true,
                                message:
                                "Enter amount"
                            }
                        ]}


                    >


                        <Input


                            prefix="$"


                            type="number"


                            placeholder="0.00"


                        />


                    </Form.Item>







                    <Row gutter={16}>


                        <Col span={12}>


                            <Form.Item


                                label="Date Taken"


                                name="date_taken"


                                rules={[
                                    {
                                        required:true
                                    }
                                ]}


                            >


                                <Input

                                    type="date"

                                />


                            </Form.Item>


                        </Col>






                        <Col span={12}>


                            <Form.Item


                                label="Date Due"


                                name="date_due"


                                rules={[
                                    {
                                        required:true
                                    }
                                ]}


                            >


                                <Input

                                    type="date"

                                />


                            </Form.Item>


                        </Col>


                    </Row>








                    <Space

                        style={{

                            width:"100%",

                            justifyContent:
                            "flex-end"

                        }}

                    >


                        <Button

                            onClick={
                                closeModal
                            }

                        >

                            Cancel

                        </Button>





                        <Button


                            type="primary"


                            htmlType="submit"


                            loading={
                                saving
                            }


                            icon={

                                editId

                                ?

                                <EditOutlined/>

                                :

                                <PlusOutlined/>

                            }


                        >


                            {
                                editId

                                ?

                                "Update"

                                :

                                "Create"

                            }


                        </Button>


                    </Space>





                </Form>



            </Modal>






        </div>


    );


}





export default Loan;
